import { IObservable, Subject } from '~/rage/utils';
import { Role } from '~/shared';
import { IAccessControlService } from './accessControlServiceTypes';

export class AccessControlServiceStub implements IAccessControlService {
	private readonly ROLE_HIERARCHY: Partial<Record<Role, number>> = {
		[Role.PLAYER]: 0,
		[Role.MODERATOR]: 1,
		[Role.ADMIN]: 2,
		[Role.DEVELOPER]: 3,
	};

	private currentRole = new Subject<Role>(Role.MODERATOR);
	private currentRoleLevel: number = this.ROLE_HIERARCHY[Role.MODERATOR] || 1;

	public getCurrentRole(): IObservable<Role> {
		return this.currentRole;
	}

	public hasMinimumRole(role: Role): boolean {
		const requiredRoleLevel = this.ROLE_HIERARCHY[role] || 1;
		return this.currentRoleLevel >= requiredRoleLevel;
	}

	public setRole(role: Role): void {
		this.currentRole.next(role);
		this.currentRoleLevel = this.ROLE_HIERARCHY[role] || 0;
	}
}
